module.exports = __webpack_public_path__ + "img/Group.1a37e319.svg";